import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const getBillingMessage = (searchParams) => {
  const reason = searchParams.get("reason") || searchParams.get("message") || "";
  return reason.trim();
};

function BillingRedirectPage() {
  const { reload } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  useEffect(() => {
    const billingStatus = searchParams.get("billing");
    const reason = getBillingMessage(searchParams);

    if (billingStatus === "success") {
      reload().finally(() => {
        navigate("/app/home?billing=success", { replace: true });
      });
      return;
    }

    if (billingStatus === "cancel") {
      const query = reason ? `?billing=cancel&reason=${encodeURIComponent(reason)}` : "?billing=cancel";
      navigate(`/app/profile${query}`, { replace: true });
      return;
    }

    if (billingStatus === "failed") {
      const query = reason ? `?billing=failed&reason=${encodeURIComponent(reason)}` : "?billing=failed";
      navigate(`/app/profile${query}`, { replace: true });
      return;
    }

    navigate("/app/profile", { replace: true });
  }, [navigate, reload, searchParams]);

  return null;
}

export default BillingRedirectPage;
